import * as S from "./StatusLabel.styled";

type StatusLabelProps = {
  success?: boolean;
  pending?: boolean;
  successLabel?: string;
  errorLabel?: string;
  pendingLabel?: string;
  started?: boolean;
  startedLabel?: string;
  resubmit?: boolean;
  resubmitLabel?: string;
  cancelled?: boolean;
  cancelledLabel?: string;
  custom?: boolean;
  customLabel?: string;
};

export const StatusLabel = (props: StatusLabelProps) => {
  const {
    success,
    pending,
    pendingLabel,
    successLabel,
    errorLabel,
    started,
    startedLabel,
    resubmit,
    resubmitLabel,
    cancelled,
    cancelledLabel,
    custom,
    customLabel,
  } = props;

  return (
    <S.StatusBox>
      <S.Status success={Boolean(success) || Boolean(custom)} pending={pending}>
        {custom
          ? customLabel
          : success
          ? successLabel
          : pending
          ? pendingLabel
          : started
          ? startedLabel
          : resubmit
          ? resubmitLabel
          : cancelled
          ? cancelledLabel
          : errorLabel}
      </S.Status>
    </S.StatusBox>
  );
};
